import { create } from "zustand";
import { persist } from "zustand/middleware";

const useAnalyticsStore = create(

  persist(
    (set) => ({
      downloadingUrl: "",
      selectedSiteId: "",
      selectedService: "",
      selectedOption: "24hours",
      selectedViolation: "",
      scenarioViolation: "",
      selectedDevice: "",
      selectedLocation: null,
      paginationUrls: {
        next: null,
        prev: null,
      },
      dateRange: [new Date().toISOString(), new Date().toISOString()],

      setDownloadingUrl: (val) => set({ downloadingUrl: val }),
      setSelectedLocation: (loc) => set({ selectedLocation: loc }),
      setSelectedSiteId: (val) => set({ selectedSiteId: val }),
      setSelectedOption: (option) => set({ selectedOption: option }),
      setSelectedViolation: (val) => set({ selectedViolation: val }),
      setScenarioViolation: (val) => set({ scenarioViolation: val }),
      setSelectedService: (val) => set({ selectedService: val }),
      setSelectedDevice: (val) => set({ selectedDevice: val }),
      setDateRange: (val) =>
        set({
          dateRange: [val[0].toISOString(), val[1].toISOString()],
        }),
      setPaginationUrls: (val) => set({ paginationUrls: val }),
    }),
    {
      name: "analytics-store",
      version: 1,
    }
  )
);

export default useAnalyticsStore;
